import React, { useEffect, useState } from "react";
import DeviceTypesTable from "./components/DeviceTypesTable";
import Edit from "./modals/Edit";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider/index";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";

function DeviceTypes(props) {
  const token = useSelector((state) => state.auth.token);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [chooseDeviceTypeId, setChooseDeviceTypeId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDeviceTypesIds, setDeleteDeviceTypesIds] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    modelId: "",

  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDeviceTypes = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      modelId,

    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceType??dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${modelId ? `&modelId=${modelId}` : ""}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setDeviceTypes(content);
        setIsError(false);
        setCount(totalElements)

      })
      .catch(() => {
        setIsLoading(false);
        setDeviceTypes([]);
        setIsError(true);
      });
  };

  const onDeviceTypeChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}deviceType/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);

  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onDeviceTypes(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  const [deviceModelId, setDeviceModelId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceModel`)
      .then(({ data: { content } }) => {
        const models = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceModelId(models);
      });
  }, []);

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğu tipləri</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DeviceTypesTable
        deviceTypes={deviceTypes}
        isLoading={isLoading}
        isError={isError}
        setChooseDeviceTypeId={setChooseDeviceTypeId}
        setShowCreate={setShowCreate}
        setShowRemove={setShowRemove}
        setShowEdit={setShowEdit}
        setDeleteDeviceTypesIds={setDeleteDeviceTypesIds}
        deleteDeviceTypesIds={deleteDeviceTypesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
      {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onDeviceTypes={onDeviceTypes}
          filterInputs={filterInputs}
          deviceModelId={deviceModelId}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        />
      )}



      {showRemove && (
        <Delete
          id={chooseDeviceTypeId}
          show={showRemove}
          onHide={setShowRemove}
          onDeviceTypes={onDeviceTypes}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}


      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onDeviceTypes={onDeviceTypes}
          id={chooseDeviceTypeId}
          onDeviceTypeChoose={onDeviceTypeChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          deviceModelId={deviceModelId}

        />
      )}


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        deviceModelId={deviceModelId}

      />

    </div>
  );
}

export default DeviceTypes;
